import { useIsMutating } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { conversationsKeys } from '@/entities/conversations';

/**
 * Перезапрашивает список диалогов, когда комментарий диалога добавлен, изменён или удалён.
 *
 * Правка комментария обесценивает выдачу списка, но одного обесценивания хватает лишь тогда,
 * когда список закрыт карточкой диалога и при возврате запрашивается заново. В лейауте, где
 * список остаётся на экране рядом с карточкой, он держит уже загруженные строки — их обновляет
 * этот перезапрос.
 *
 * @param onReload - Перезапрос показанных строк списка
 */
export const useCommentChangeReload = (onReload: () => void) => {
  const pendingCount = useIsMutating({ mutationKey: conversationsKeys.comments() });
  const prevPendingCountRef = useRef(pendingCount);

  useEffect(() => {
    const wasPending = prevPendingCountRef.current > 0;
    prevPendingCountRef.current = pendingCount;
    if (wasPending && pendingCount === 0) onReload();
  }, [pendingCount, onReload]);
};
